/* eslint-disable react/prop-types */
import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Collapse, makeStyles } from "@material-ui/core";
import _ from "lodash";
import {
  reduceEstimations,
  groupEstimationsByKeyAndProduct,
} from "lib/filters/estimations";
import EstimationsListComponent from "./EstimationsListComponent";

const useStyles = makeStyles((theme) => ({
  collapseSummary: {
    backgroundColor: "#FFFFFF",
    borderRadius: "3px",
    border: "1px solid #e2e2e2",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
    borderLeft: `5px solid ${theme.palette.primary.main}`,
    marginTop: "10px",
    minHeight: 56,
    padding: "15px",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#ECEFF1",
    },
  },
  collapseDetails: {
    flexDirection: "column",
    height: "80vh",
    boxShadow: "0 1px 4px 0 rgba(37, 50, 56, 0.1)",
  },
  collapseRoot: {
    padding: "20px",
    border: "1px solid #e2e2e2",
  },
  collapseWrapperInner: {
    overflow: "auto",
  },
  selectedRow: {
    backgroundColor: "#ECEFF1",
  },
}));

export default function EstimationsGroupComponent({
  scenarioEstimations,
  referenceEstimations,
  filters,
  itemList,
  groupBy,
  metadata,
}) {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const scenariosSlice = useSelector((state) => state.scenarios);
  const configCatSlice = useSelector((state) => state.auth.configCatUser);
  const [groupedScenarioEstimations, setGroupedScenarioEstimations] = useState(
    groupEstimationsByKeyAndProduct(scenarioEstimations, groupBy)
  );
  const [
    groupedReferenceEstimations,
    setGroupedReferenceEstimations,
  ] = useState(groupEstimationsByKeyAndProduct(referenceEstimations, groupBy));

  const classes = useStyles();

  const handleRowClick = (itemId) => {
    if (selectedIndex === itemId) setSelectedIndex(-1);
    else setSelectedIndex(itemId);
  };

  useMemo(() => {
    setGroupedScenarioEstimations(
      groupEstimationsByKeyAndProduct(scenarioEstimations, groupBy)
    );
  }, [scenarioEstimations]);

  useMemo(() => {
    setGroupedReferenceEstimations(
      groupEstimationsByKeyAndProduct(referenceEstimations, groupBy)
    );
  }, [referenceEstimations]);

  return _.map(itemList, (item) => {
    if (
      filters[groupBy] &&
      !Array.from(filters[groupBy]).some((filter) => filter.id === item.id)
    )
      return null;

    const refEstimations = reduceEstimations(
      groupedReferenceEstimations[item.id],
      groupBy,
      metadata,
      configCatSlice?.features.newInvestmentCalculation
    );

    const selectedEstimations = reduceEstimations(
      groupedScenarioEstimations[item.id],
      groupBy,
      metadata,
      scenariosSlice.referenceScenario.estimations,
      configCatSlice?.features.newInvestmentCalculation
    );

    return (
      <Box key={item.id}>
        {!_.isEmpty(refEstimations) && !_.isEmpty(selectedEstimations) && (
          <Box
            onClick={() => handleRowClick(item.id)}
            className={`${classes.collapseSummary} ${item.id ===
              selectedIndex && classes.selectedRow}`}
          >
            <Typography>{item.label}</Typography>
          </Box>
        )}
        <Collapse
          classes={{
            container: classes.collapseRoot,
            wrapperInner: classes.collapseWrapperInner,
          }}
          in={item.id === selectedIndex}
          timeout={0}
          unmountOnExit
        >
          <Box className={classes.collapseDetails}>
            <EstimationsListComponent
              key={groupBy}
              groupBy={groupBy}
              referenceEstimations={refEstimations}
              scenarioEstimations={selectedEstimations}
            />
          </Box>
        </Collapse>
      </Box>
    );
  });
}
